import { render, staticRenderFns } from "./ReceiveRequestHistoriesTable.vue?vue&type=template&id=0f0cc7ce&scoped=true&lang=pug"
import script from "./ReceiveRequestHistoriesTable.vue?vue&type=script&lang=ts"
export * from "./ReceiveRequestHistoriesTable.vue?vue&type=script&lang=ts"
import style0 from "./ReceiveRequestHistoriesTable.vue?vue&type=style&index=0&id=0f0cc7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0cc7ce",
  null
  
)

export default component.exports